// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__2bNrD","join":"home_join__3W5r4","content":"home_content__3j1fg"};